import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Grid, Dropdown, Input} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {invoiceQueryStatus} from '../../../common/constants/lists';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {downloadFile} from '../../../common/util/file';
import InvoiceQueryTable from './table';
import './invoicesList.scss';

class InvoiceQuery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showTable': false,
      'invoiceNumberFilter': '',
      'dealerIdFilter': '',
      'providerIdFilter': '',
      'statusFilter': '',
      'startDateFilter': '',
      'endDateFilter': '',
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.InvoiceQuery, scopes.See) &&
    !hasAccessPermission(this.props.permissions, resources.InvoiceQuery, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchDealers('importers');
    this.props.loadProviders({'fields': 'code,name'});
    this.props.clearInvoicesData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.oderNoteUrl !== this.props.oderNoteUrl && this.props.oderNoteUrl) {
      downloadFile(this.props.oderNoteUrl);
      this.props.clearOrderNoteUrl();
    }
  }

  onCancelClick() {
    const {invoicesCount} = this.props;
    this.setState({
      'showTable': false,
      'invoiceNumberFilter': '',
      'dealerIdFilter': '',
      'providerIdFilter': '',
      'statusFilter': '',
      'startDateFilter': '',
      'endDateFilter': '',
    });
    if (invoicesCount) {
      this.props.clearInvoicesData();
    }
  }

  disableCancelButton() {
    const {loadingDealers, loadingProviders} = this.props;
    const {invoiceNumberFilter, dealerIdFilter, providerIdFilter, statusFilter,
      startDateFilter, endDateFilter} = this.state;
    const emptyAllFilters = !invoiceNumberFilter && !dealerIdFilter && !providerIdFilter &&
      !statusFilter && !startDateFilter && !endDateFilter;
    return loadingDealers || loadingProviders || emptyAllFilters;
  }

  disableSearchButton() {
    const {loadingDealers, loadingProviders} = this.props;
    const {invoiceNumberFilter, startDateFilter, endDateFilter} = this.state;
    const requiredFilters = invoiceNumberFilter || (startDateFilter && endDateFilter);
    return loadingDealers || loadingProviders || !requiredFilters;
  }

  getFilters() {
    const {invoiceNumberFilter, dealerIdFilter, providerIdFilter, statusFilter,
      startDateFilter, endDateFilter} = this.state;
    const filters = {
      'invoice': invoiceNumberFilter,
      'dealerId': dealerIdFilter,
      'providerId': providerIdFilter,
      'status': statusFilter,
      'startDate': startDateFilter,
      'endDate': endDateFilter,
    };
    Object.keys(filters).forEach((key) => {
      if (!filters[key]) {
        delete filters[key];
      }
    });
    return filters;
  }

  onSearchClick() {
    this.setState({'showTable': true});
    const filters = this.getFilters();
    this.props.fetchInvoices(filters);
  }

  onInvoiceNumberFilterChange(event) {
    this.setState({'invoiceNumberFilter': (event.target.value).toUpperCase()});
  }

  getDealers() {
    return this.props.dealers.map((element) => {
      return {'text': element.name, 'value': element.identification};
    });
  }

  changeDealer(value) {
    if (value !== this.state.dealerIdFilter) {
      this.setState({'dealerIdFilter': value});
    }
  }

  getProviders() {
    return this.props.providers.map((element) => {
      return {'text': `${element.code} - ${element.name}`, 'value': element.code};
    });
  }

  changeProvider(value) {
    if (value !== this.state.providerIdFilter) {
      this.setState({'providerIdFilter': value});
    }
  }

  changeStatus(value) {
    if (value !== this.state.statusFilter) {
      this.setState({'statusFilter': value});
    }
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted !== startDateFilter) {
      this.setState({'startDateFilter': dateFormatted});
    }
    if (!endDateFilter) {
      this.setState({'endDateFilter': dateFormatted});
    }
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    if (dateFormatted !== this.state.endDateFilter) {
      this.setState({'endDateFilter': dateFormatted});
    }
  }

  render() {
    const {loadingDealers, loadingProviders} = this.props;
    const {showTable, invoiceNumberFilter, dealerIdFilter, providerIdFilter, statusFilter,
      startDateFilter, endDateFilter} = this.state;

    return (
      <div className='invoices-query-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta de Facturas</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={this.disableCancelButton()}
                  onClick={this.onCancelClick.bind(this)}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={this.disableSearchButton()}
                  onClick={this.onSearchClick.bind(this)}
                >
                  Buscar
                </Button>
              </div>
            </div>

            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Número Factura</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Input
                      type='text'
                      placeholder='Número Factura'
                      value={invoiceNumberFilter}
                      onChange={this.onInvoiceNumberFilterChange.bind(this)}
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Importador</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Dropdown selection
                      options={this.getDealers()}
                      search
                      value={dealerIdFilter}
                      disabled={loadingDealers}
                      loading={loadingDealers}
                      onChange={(e, {value}) => this.changeDealer(value)}
                      placeholder='Seleccione Importador'
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Proveedor</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Dropdown selection
                      options={this.getProviders()}
                      search
                      value={providerIdFilter}
                      disabled={loadingProviders}
                      loading={loadingProviders}
                      onChange={(e, {value}) => this.changeProvider(value)}
                      placeholder='Seleccione Proveedor'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Estado</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Dropdown selection
                      options={invoiceQueryStatus}
                      search
                      value={statusFilter}
                      onChange={(e, {value}) => this.changeStatus(value)}
                      placeholder='Seleccione Estado'
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Fecha Inicio</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={startDateFilter ? moment(startDateFilter, noTimeZoneShortISODate).toDate() : null}
                      onChange={this.changeStartDate.bind(this)}
                      locale='es'
                      placeholderText='Fecha Inicio'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Fecha Fin</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={endDateFilter ? moment(endDateFilter, noTimeZoneShortISODate).toDate() : null}
                      onChange={this.changeEndDate.bind(this)}
                      locale='es'
                      placeholderText='Fecha Fin'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        {showTable && <InvoiceQueryTable />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingDealers': state.dealer.loading,
    'dealers': state.dealer.list,
    'loadingProviders': state.provider.loading,
    'providers': state.provider.list,
    'loading': state.invoicesQuery.loading,
    'invoicesCount': state.invoicesQuery.list.length,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'oderNoteUrl': state.invoicesQuery.oderNoteUrl,
  };
};

const {
  navigateTo,
  fetchDealers,
  loadProviders,
  fetchInvoices,
  clearInvoicesData,
  generateOrderNote,
  clearOrderNoteUrl,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchDealers,
  loadProviders,
  fetchInvoices,
  clearInvoicesData,
  generateOrderNote,
  clearOrderNoteUrl,
})(InvoiceQuery);
